export default __webpack_public_path__ + "static/media/play.c362523b.svg";